import { useDynamicWidgets } from 'react-instantsearch'

import * as S from './styled'
import { FilterType } from '../FilterType'
import { AppliedFilters } from '../AppliedFilters'
import { HierarchicalMenu } from './components'
import { MappedAttributes } from '../../utils/filterToRender'

const Filters = () => {
  const widgets = useDynamicWidgets()

  return (
    <S.Wrapper>
      <AppliedFilters />
      <HierarchicalMenu filterIndex={0} />

      {widgets.attributesToRender.map((item, index) => (
        <FilterType
          key={`${item}-${index}`}
          attribute={item as MappedAttributes}
          filterIndex={index + 1}
        />
      ))}
    </S.Wrapper>
  )
}

export default Filters
